import {Component, effect, EventEmitter, inject, input, Input, Output} from '@angular/core';
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";
import {NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {PaddockSvgComponent} from "src/app/presentation/common/icons/paddock-svg/paddock-svg.component";
import {Animal, Paddock} from "src/app/infrastructure/moovement-api/models/asset";
import {AnimalSelectionStore} from 'src/app/domain/assets/animals/animal-selection.store';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-paddock',
  imports: [
    AnimalButtonComponent,
    NgClass,
    PaddockSvgComponent
  ],
  templateUrl: './paddock.component.html',
  styleUrl: './paddock.component.css'
})
export class PaddockComponent {

  focusOnClick = input(true);
  openPaddocks = input<Set<string>>(new Set());
  total = input<number | undefined>(undefined);

  @Input() paddock!: Paddock;
  @Input() animals!: Array<Animal>;
  @Input() selected: boolean = false;
  @Input() open: boolean = false;

  @Output() clickedOpenClose: EventEmitter<string> = new EventEmitter();
  @Output() paddockSelected: EventEmitter<boolean> = new EventEmitter();

  selectableForAlteration: boolean = false;
  selectableForDeletion: boolean = false;

  private selectedAnimals: Array<Animal> = []

  private animalSelectionStore = inject(AnimalSelectionStore);
  private userStore = inject(UserStore);
  protected dataSubscriptionService = inject(DataSubscriptionService);

  constructor() {
    effect(() => {
      this.selectableForAlteration = this.animals.some(animal => this.userStore.canEditPersistable(animal));
      this.selectableForDeletion = this.animals.some(animal => this.userStore.canDeletePersistable(animal));
    });

    effect(() => {
      const selectedAnimals = this.animalSelectionStore.entities();
      this.selectedAnimals = selectedAnimals;
      this.selected = selectedAnimals.length > 0
        && this.animals.length > 0
        && this.animals.every(animalInPaddock => this.selectedAnimals.includes(animalInPaddock));
    });

    effect(() => {
      this.open = this.openPaddocks().has(this.paddock.id);
    });
  }

  onCheckUncheck() {
    this.selected = !this.selected;

    if (this.selected) {
      this.animalSelectionStore.addEntities(this.animals);
    } else {
      const animalsIds = this.animals.map(animal => animal.id);
      this.animalSelectionStore.removeEntities(animalsIds);
    }

    this.paddockSelected.emit(this.selected)
  }

  animalIsSelected(animal: Animal): boolean {
    return this.selectedAnimals.includes(animal)
  }

  togglePaddock() {
    this.open = !this.open
    if (this.open) {
      this.openPaddocks().add(this.paddock.id);
    } else {
      this.openPaddocks().delete(this.paddock.id);
    }
    this.clickedOpenClose.emit(this.paddock.id)
  }
}
